// extracted by mini-css-extract-plugin
module.exports = {"container":"DetailInfo_container__3WmN9","header":"DetailInfo_header__2_NAV","descriptions":"DetailInfo_descriptions__1H_cq","empty":"DetailInfo_empty__2kKO9"};